<template>
  <div class="sm:w-max-3xl w-full">
    <vs-table class="w-full relative" ref="table" v-model="selected">
      <template #thead>
        <vs-tr>
          <vs-th class="!w-2">
            <i class="bx bx-check" />
          </vs-th>
          <vs-th class="!w-1/3"> Id </vs-th>
          <vs-th> Name </vs-th>
          <vs-th> Steam Id </vs-th>
          <vs-th> Created At</vs-th>
        </vs-tr>
      </template>
      <template #tbody v-if="games">
        <vs-tr
          :key="i"
          v-for="(game, i) in games.docs"
          :data="game"
          class="cursor-pointer"
          :is-selected="selected === game"
        >
          <vs-td>
            <i v-if="checkActive(game)" class="bx bx-x"></i>
            <i v-else class="bx bx-check"></i>
          </vs-td>
          <vs-td>
            {{ game._id }}
          </vs-td>
          <vs-td> {{ game.name }}</vs-td>
          <vs-td> {{ game.steamID }}</vs-td>
          <vs-td>
            {{ game.createdAt | formatTimestamp }}
          </vs-td>
        </vs-tr>
      </template>
      <template #footer v-if="games">
        <vs-pagination v-model="page" :length="games.totalPages" />
      </template>
    </vs-table>
  </div>
</template>

<script>
import { getAllGamesByAdmin } from "@/services/ApiService";

export default {
  name: "GameTable",
  props: {
    games: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    page: 1,
    max: 10,
    selected: null,
  }),
  methods: {
    async getGames() {
      const loading = this.$vs.loading({
        target: this.$refs.table,
        background: "rgba(0, 0, 0, 0.6)",
        color: "primary",
        type: "points",
      });

      const { data } = await getAllGamesByAdmin(this.page);
      this.games = data;

      loading.close();
    },
    checkActive(plan) {
      return plan.deleted || plan.hidden;
    },
  },
  watch: {
    page() {
      this.getGames();
    },
    selected: {
      handler() {
        const id = this.selected._id;
        this.$router.push({
          name: "createGame",
          params: { id },
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
